module.exports = __webpack_public_path__ + "static/media/golfer.3bb62cf3.png";